import { DatePipe } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonHttpServiceService } from "src/app/admin/Services/common-http-service.service";
import { ChannelModel, FrequencyModel, RegionModel } from "src/app/model/contract/channel";
import { StateModel } from "src/app/model/contract/menu-program";
import { RegionDataService } from "src/app/model/region-data.service";
import { SettingDataService } from "src/app/model/setting-data.service";
import { GeneralService } from "src/app/report-dashboard/Services/general.service";
import { HubAdminDataProvider } from "src/app/shared/Providers/ModuleDataProvider/HubAdminDataProviders";
import { AlertService } from "src/app/shared/Providers/RouterProvider/AlertProvider";
import { RouteDataProvider } from "src/app/shared/Providers/RouterProvider/RouteDataProvider.provider";
import { CommonProvider } from "src/app/shared/Providers/Shared/CommonProvider";
import { DROPDOWN_DETAILS } from "src/app/nesa-admin/Models/general-headings.model";
import { FilterModel } from "../Models/filter-data";
import { TabDirective, TabsetComponent } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ViewChild } from "@angular/core";

@Component({
  selector: "app-nesa-dashboard",
  templateUrl: "./nesa-dashboard.component.html",
  styleUrls: ["./nesa-dashboard.component.scss"],
})
export class NesaDashboardComponent implements OnInit {
  @ViewChild(TabsetComponent, { static: false }) tabset: TabsetComponent;
  selectedNewRegion: number = 0;
  dateRange: any = [];
  states: StateModel[];
  channels: ChannelModel[];
  frequency: FrequencyModel[];
  regions: RegionModel[];
  m1Users: any[];
  m2Users: any[];
  m3Users: any[];
  dropdown: any[] = DROPDOWN_DETAILS;
  regionsData: RegionModel[];
  statesData: StateModel[];
  selectedStates: StateModel[];
  min: number;
  max: number;
  smonth: any = "0";
  sdate: any = "0";
  region = "";
  state = "";
  channel = "";
  m1 = "";
  m2 = "";
  m3 = "";
  region_id: any;
  program_id: string;
  options: Array<any> = [];
  data;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public routerDataProvider: RouteDataProvider,
    public commonProvider: CommonProvider,
    public datepipe: DatePipe,
    public hubAdminDataProvider: HubAdminDataProvider,
    public generalService: GeneralService,
    public ngxLoader: NgxUiLoaderService,
    public alertService: AlertService,
    private httpClient: CommonHttpServiceService,
    private toastr: ToastrService,
    private settingDataService: SettingDataService,
    private usersService: RegionDataService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
      /** spinner starts on init */
      this.spinner.show();
    this.program_id = localStorage.getItem("program_id");
    this.region_id = parseInt(localStorage.getItem("region_id"));
    console.log(this.region_id);
    console.log(this.dropdown);
    this.getRegions();
    (this.min = 2019), (this.max = new Date().getFullYear());
    if (typeof parseInt(localStorage.getItem("calendar_year")) != "undefined") {
      this.min = parseInt(localStorage.getItem("calendar_year"));
      this.max = parseInt(localStorage.getItem("calendar_year"));
      this.sdate = parseInt(localStorage.getItem("calendar_year"));
    }
    let options = "<option>Select Year</option>";
    for (var i = this.min; i <= this.max; i++) {
      options += '<option value="' + i + '">' + i + "</option>";
      this.options.push(i);
    }
    this.options.reverse();
  }

  getRegions(): void {
    this.settingDataService.getAllRegion().subscribe(
      (result: any) => {
        this.regionsData = result.data.regions;
        this.getStateList();
        if (typeof this.regionsData != "undefined") {
          if (this.regionsData.length > 0) {
            this.regionsData = this.regionsData.filter(
              (i) => i.id == this.region_id
            );
            this.selectedNewRegion = this.regionsData.find(
              (i) => i.id == this.region_id
            ).id;
          }
        }
        this.regionsData.forEach((ele) => {
          ele.itemName = ele.region_name;
          ele.checked = false;
          ele.name = ele.region_name;
        });
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  getStateList(): void {
    this.usersService.getAllStates().subscribe((data) => {
      this.states = data;
      this.dropdown.find((d) => d.id == 2).data = this.states.filter(
        (i) => i.region_id == this.selectedNewRegion
      );
      this.states.forEach((s) => {
        s.name = s.state_name;
        s.id = s.state_code;
      });
    });
  }

  ngDoCheck() {
    this.states = this.commonProvider.states;
    this.m1Users = this.commonProvider.tseUsers;
    this.m2Users = this.commonProvider.m2Users;
    this.m3Users = this.commonProvider.m3Users;
    this.channels = this.commonProvider.channelList;
    this.dropdown.find((d) => d.id == 3).data = this.channels;
    this.dropdown.find((d) => d.id == 4).data = this.m1Users;
    this.dropdown.find((d) => d.id == 5).data = this.m2Users;
    this.dropdown.find((d) => d.id == 6).data = this.m3Users;
  }

  StatesfilterByRegion: any[];
  resetDropdown: boolean;

  getList(event, mainData) {
    this[mainData] = event;
    var z = [];
    var g;
    if (event.length != 0) {
      event.forEach((element) => {
        z.push(element.id);
      });
      g = z.join();
      this[mainData] = z;
    } else {
      g = "";
    }
    return g;
  }

  value: string;
  onSelect(data: TabDirective): void {
    debugger
    this.value = data.heading;
    console.log(this.value);
    debugger
  }

  selectedValueCheck(event, filter): void {
    // console.log("general:", event, filter);
    console.log(event);

    switch (filter) {
      case 1:
        this.StatesfilterByRegion = [];
        if (event != 0) {
          event.forEach((element) => {
            let data = this.states.filter((s) => s.region_id == element.id);
            this.StatesfilterByRegion.push(...data);
          });
        }
        this.region = this.getList(event, "selectedRegion");
        console.log(this.region);
        this.dropdown.find((d) => d.id == 2).data = this.StatesfilterByRegion;
        break;
      case 2:
        ;
        this.state = this.getList(event, "selectedState");
        localStorage.setItem("selectedstates", JSON.stringify(event));
        console.log(event);
        break;
      case 3:
        this.channel = this.getList(event, "selectedChannel");
        localStorage.setItem("selectedchannels", JSON.stringify(event));
        break;
      case 4:
        this.m1 = this.getList(event, "selectedM1");
        localStorage.setItem("selectedm1s", JSON.stringify(event));
        break;
      case 5:
        // this.selectedM2 = event;
        this.m2 = this.getList(event, "selectedM2");
        localStorage.setItem("selectedm2s", JSON.stringify(event));
        break;
      case 6:
        // this.selectedM3 = event;
        this.m3 = this.getList(event, "selectedM3");
        localStorage.setItem("selectedm3s", JSON.stringify(event));
        break;
    }
    // this.searchByFilter();
  }

  resetFilter() {
    this.resetDropdown = true;
    this.dateRange = [];
    // window.location.reload();
    window.location.reload();
    // this.router.navigateByUrl('/region-admin/general')
    console.log("Reset");
  }

  errorMsg: any = "";
  errorMsg1: any = "";
  whitelist_date: any = 0;
  whitelist_date1: any;
  selectedRegion: number[] = [];
  selectedState: number[] = [];
  selectedChannel: number[] = [];
  selectedM1: number[] = [];
  selectedM2: number[] = [];
  selectedM3: number[] = [];
  startDate: any;
  endDate: any;


  searchByFilter() {
    this.errorMsg = "";
    this.errorMsg1 = "";

    this.resetDropdown = false;
    if (this.whitelist_date == 0) {
      this.whitelist_date1 = 0;
    } else {
      this.whitelist_date1 = this.datepipe.transform(
        this.whitelist_date,
        "yyyy-MM-dd"
      );
    }
    if (this.dateRange.length == 0) {
      this.startDate = 0;
      this.endDate = 0;
    } else {
      this.startDate = this.datepipe.transform(this.dateRange[0], "yyyy-MM-dd");
      this.endDate = this.datepipe.transform(this.dateRange[1], "yyyy-MM-dd");
    }

    if (this.selectedNewRegion === undefined || this.selectedNewRegion == 0) {
      this.selectedNewRegion = 0;
    }

    if (this.selectedState === undefined || this.selectedState.length == 0) {
      this.state = "";
    }

    if (
      this.selectedChannel === undefined ||
      this.selectedChannel.length == 0
    ) {
      this.channel = "";
    }

    if (this.selectedM1 === undefined || this.selectedM1.length == 0) {
      this.m1 = "";
    }

    if (this.selectedM2 === undefined || this.selectedM2.length == 0) {
      this.m2 = "";
    }

    if (this.selectedM3 === undefined || this.selectedM3.length == 0) {
      this.m3 = "";
    }
    ;

    if (this.smonth == "0" && this.sdate == "0") {
      this.errorMsg = "Please select year";
      this.errorMsg1 = "Please select month";
    } else {
      if (typeof this.smonth != "undefined") {
        if (parseInt(this.smonth) != 0) {
          if (parseInt(this.sdate) != 0) {
           this.data = new FilterModel();
            this.data.startDate = this.startDate;
            this.data.endDate =  this.endDate;
            this.data.selectedNewRegion = this.selectedNewRegion
            this.data.state = this.state;
            this.data.channel = this.channel;
            this.data.m1 = this.m1;
            this.data.m2 = this.m2;
            this.data.m3 = this.m3;
            this.data.whitelist_date1 = this.whitelist_date1;
            this.data.smonth = this.smonth;
            this.data.sdate = this.sdate;
          } else {
            this.errorMsg = "Please select year";
          }
        }
      }

      if (typeof this.sdate != "undefined") {
        if (parseInt(this.sdate) != 0) {
          if (parseInt(this.smonth) != 0) {
            let data = new FilterModel();
            data.startDate = this.startDate;
            data.endDate =  this.endDate;
            data.selectedNewRegion = this.selectedNewRegion
            data.state = this.state;
            data.channel = this.channel;
            data.m1 = this.m1;
            data.m2 = this.m2;
            data.m3 = this.m3;
            data.whitelist_date1 = this.whitelist_date1;
            data.smonth = this.smonth;
            data.sdate = this.sdate;
          } else {
            this.errorMsg1 = "Please select month";
          }
        }
      }
    }
  }

  show: boolean = true;

  getActiveTab() {
    const activeTab = this.tabset.tabs.filter((tab) => tab.active);
    console.log(activeTab[0].heading);
    let heading = activeTab[0].heading;
    if (heading == "Mystery Shopper Outlet Level Detail" || heading == "Menu Programs") {
      this.show = false;
    } else {
      this.show = true;
    }
  }



}
